import { IAdminUserService } from './IAdminUserService';
import { AdminApi } from 'infrastructure/apis/admin';
import { AdminUsersQueryDTO, AdminUsersResponseDTO } from 'infrastructure/dtos/admin';

export class AdminUserService implements IAdminUserService {
  constructor(private readonly api: AdminApi) {}

  async getUsers(query: AdminUsersQueryDTO): Promise<AdminUsersResponseDTO> {
    return await this.api.getUsers(query);
  }
}
